import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetMyReferralsV1Response } from './get-my-referrals-v1-response';
import { getMyReferralsV1ResponseSchema } from './get-my-referrals-v1-response';

export async function getMyReferralsV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetMyReferralsV1Response>> {
  return getRequest<IGetMyReferralsV1Response>({
    path: '/account/referrals/v1',
    schema: getMyReferralsV1ResponseSchema,
    options,
  });
}
